import { FC, useState } from 'react';
import { Stack } from '@mui/material';

import Modal from '@/components/ui/Modal';
import CTAButton from '@/components/ui/CTAButton';
import { dialogAktionenSx } from '@/theme/bausteine';
import api from '@/services/api';
import useKundenMailRueckfrageStore from '@/store/kundenMailRueckfrage';
import useToastStore from '@/store/toast';
import { ErrorResponse } from '@/utils';

/**
 * Rückfrage nach geänderter Kunden-Mail (Decision #254, Planänderung B,
 * Entscheid Alex 05.11.2026). „Nein“ und Fenster zu senden nichts; das Backend
 * sendet erst, wenn hier „Ja“ kommt.
 */
const KundenMailRueckfrageDialog: FC = () => {
  const kennung = useKundenMailRueckfrageStore((s) => s.kennung);
  const schliessen = useKundenMailRueckfrageStore((s) => s.schliessen);
  const showToast = useToastStore((s) => s.showToast);
  const [sendet, setSendet] = useState(false);

  const ja = async () => {
    if (!kennung) return;
    setSendet(true);
    try {
      showToast(await api.customer.sendeKundenMailRueckfrage(kennung), 'success');
    } catch (error) {
      const fachlich = (error as ErrorResponse).getResponseData?.<{ error?: { message?: string } }>()?.error?.message;
      showToast(fachlich ?? 'Das Senden ist fehlgeschlagen.', 'error');
    } finally {
      setSendet(false);
      schliessen();
    }
  };

  const ActionArea = () => (
    <Stack sx={dialogAktionenSx}>
      <CTAButton label="Nein" variant="tertiary" onClick={schliessen} autoWidth disabled={sendet} />
      <CTAButton label="Ja" variant="secondary" onClick={ja} autoWidth disabled={sendet} />
    </Stack>
  );

  return (
    <Modal
      open={kennung !== null}
      onClose={schliessen}
      title="Bevorstehendes Meeting. Bestätigung + Reminder neu senden?"
      ActionArea={ActionArea}
    />
  );
};

export default KundenMailRueckfrageDialog;
